import React from "react"
import types from "prop-types"
import { ChevronUp, ChevronDown } from "shared/icons"

const SidebarAccordionHeader = ({ accordionTitle, isExpanded, toggleAccordion }) => (
  <button className="flex-center flex justify-between text-sm cursor-pointer w-full" onClickCapture={toggleAccordion} tabIndex={0}>
    <span
      aria-label={`${isExpanded ? "hide" : "show"} ${accordionTitle}`}
      className="font-semibold tracking-wider uppercase"
    >
      {accordionTitle}
    </span>
    {
      isExpanded ? (
        <ChevronDown className="flex h-3 w-3" />
      ) : (
        <ChevronUp className="flex h-3 w-3" />
      )
    }
  </button>
)

SidebarAccordionHeader.propTypes = {
  accordionTitle: types.string.isRequired,
  isExpanded: types.bool.isRequired,
  toggleAccordion: types.func.isRequired,
}

export default SidebarAccordionHeader
